import { $themeConfig } from '@themeConfig'

const storedCollapsed = localStorage.getItem('dutton_menu_collapsed')
const initialCollapsed = storedCollapsed !== null
  ? storedCollapsed === 'true'
  : $themeConfig.layout.menu.isCollapsed

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: initialCollapsed,
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
      localStorage.setItem('dutton_menu_collapsed', val)
    },
  },
  actions: {},
}
